import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import InstantSearch from "../../../ui/components/InstantSearch/InstantSearch";
import { InstantSearchHits } from "../../../ui/components/InstantSearch/InstantSearchData";

import Table from "../../../tables/components/Table";

import HomeLayout from "../../layouts/HomeLayout/HomeLayout";

import useUpcomingTitlesColumns from "./hooks/useUpcomingTitlesColumns";

const today = Math.round(Date.now() / 1000);
const in20Days = today + 20 * 24 * 60 * 60;

export default function UpcomingTitlesWidget({ organization, language }) {
	const { t } = useTranslation();
	const navigate = useNavigate();

	const columns = useUpcomingTitlesColumns();

	const configure = {
		filters: [
			`${organization.type}.id:${organization.id}`,
			`releaseDates >= ${today}`,
			`releaseDates <= ${in20Days}`,
			language && `language:${language}`,
		]
			.filter(Boolean)
			.join(" AND "),
	};

	return (
		<HomeLayout.Widget icon="sync" color="red" header={t("upcomingTitles", "Upcoming titles")}>
			<InstantSearch indexName="articles" configure={configure}>
				<InstantSearchHits>
					{({ data }) => {
						return (
							<Table
								data={data}
								columns={columns}
								onClick={({ work }) => navigate(`works/${work?.id}`)}
								noDataAvailableMessage={t("noUpcomingTitles", "You have no upcoming titles")}
								getDropdownMenuOptions={({ work }) => [
									{
										text: t("view", "View"),
										linkTo: `works/${work?.id}`,
									},
								]}
							/>
						);
					}}
				</InstantSearchHits>
			</InstantSearch>
		</HomeLayout.Widget>
	);
}
